// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.terms-understand {
  font-size: 16px;
  color: #333333;
}

.popupBreak {
  margin-top: 20px;
}

.fanlist-without-accordion > p {
  margin-bottom: 30px;
}

.checkbox .skin {
  border: 1px solid #cccccc;
}

.fanlist-with-accordion .accordion {
  border-bottom: none !important;
  margin-bottom: 0px !important;
}

.signup-review-section {
  margin: 0 16.66%;
}
.signup-review-section .review-btn-cancel {
  padding-top: 10px;
}
.signup-review-section .label-review {
  font-family: "Omnes-ATT-W02-Medium";
}
.signup-review-section .icon-alert {
  color: #ffb81c !important;
  margin: 0;
}
.signup-review-section .table {
  margin-bottom: 30px !important;
}
.signup-review-section .enrollDateInfo {
  margin: 0;
}
.signup-review-section .enrollDateInfo a {
  padding: 0;
}
.signup-review-section .enrollDateInfo .alert-icon {
  width: 20px;
  float: left;
  margin-right: 10px;
}
.signup-review-section .enrollDateInfo .extra-content {
  float: left;
  width: 88%;
}
.signup-review-section .enrollDateInfo .icon-alert {
  width: 20px;
  height: 20px;
}
.signup-review-section h3 {
  color: #191919;
  font: 2.4rem "Omnes-ATT-W02";
}
.signup-review-section a {
  padding-right: 30px;
}
.signup-review-section .btn-link {
  font: 1.8rem "Omnes-ATT-W02";
}
.signup-review-section h3 a {
  cursor: pointer;
  font-size: 16px;
}
.signup-review-section .checkbox span {
  font-family: "Omnes-ATT-W02";
}
.signup-review-section .fanlist-with-accordion {
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 20px;
}
.signup-review-section .service-type {
  margin-bottom: 30px;
  padding-top: 10px;
}
.signup-review-section .service-type p {
  margin-bottom: 0px;
}
.signup-review-section .editable-container {
  border-top: 1px solid #d2d2d2;
  margin-bottom: 30px;
  padding-top: 30px;
}
.signup-review-section .editable-container.have-no-accordion {
  border-top: 1px solid #d2d2d2;
  margin-bottom: 30px;
  padding-top: 30px;
}
.signup-review-section .editable-container p {
  margin-bottom: 0;
}
.signup-review-section tr th:first-child {
  width: 15%;
}
.signup-review-section .fanlist-without-accordion .isMobileDevice {
  display: none;
}
.signup-review-section ul li {
  list-style-type: disc;
  margin-left: 15px;
}
.signup-review-section .reviewunderstand {
  border-radius: 5px;
  border-radius: 5px;
  border-radius: 5px;
  border-radius: 5px;
  border-radius: 5px;
  background-color: hsl(0, 0%, 95%);
  border: 0 none;
  margin-bottom: 30px;
  padding: 20px;
}
.signup-review-section .reviewunderstand p {
  margin-bottom: 20px;
}
.signup-review-section .reviewunderstand div {
  margin-bottom: 0;
}
.signup-review-section .reviewunderstand div:last-child {
  margin-bottom: 0;
}
.signup-review-section .reviewunderstand h3.google-acknowledge {
  font-size: 20px;
  font-family: "Omnes-ATT-W02-Medium";
}
.signup-review-section .buttons-section {
  border-top: 1px solid #d2d2d2;
  padding: 30px 0 60px;
}
.signup-review-section .error-text {
  color: hsl(0, 66%, 49%);
}
.signup-review-section .error-text .skin {
  border: 1px solid hsl(0, 66%, 49%);
}
.signup-review-section .app-list {
  list-style-type: disc;
  margin-left: 15px;
}
.signup-review-section .accordion-grid {
  border-bottom: 1px solid #d2d2d2;
  margin: 30px 0 30px;
}
.signup-review-section .accordion-grid {
  border-bottom: 0px;
}
@media (max-width: 1024px) {
  .signup-review-section {
    margin: 0 15px;
  }
  .signup-review-section .review-btn-cancel {
    padding: 20px 19px 0 18px;
  }
  .signup-review-section .btn-cancel {
    margin: 10px 0;
    text-align: center;
    width: 100%;
  }
  .signup-review-section .btn {
    margin: 0;
    text-align: center;
    width: 100%;
  }
  .signup-review-section .service-type {
    margin-bottom: 20px;
    padding-top: 0px;
  }
  .signup-review-section .editable-container {
    margin-bottom: 20px;
    padding-top: 20px;
  }
  .signup-review-section .editable-container.have-no-accordion {
    margin-bottom: 20px;
    padding-top: 20px;
  }
  .signup-review-section .editable-container div {
    margin-bottom: 20px;
  }
  .signup-review-section .editable-container div.securitypolicy {
    margin-bottom: 30px;
  }
  .signup-review-section .reviewunderstand {
    margin-bottom: 20px;
  }
  .signup-review-section .reviewunderstand h3 {
    font-size: 20px;
    margin-bottom: 20px;
    font-family: "Omnes-ATT-W02-Medium";
  }
  .signup-review-section .buttons-section {
    padding: 20px 0 30px;
  }
  .signup-review-section .grid-table {
    margin-left: -15px;
    margin-right: -15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup/review/review.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,eAAA;EACA,cAAA;AAmJJ;;AAhJA;EACE,gBAAA;AAmJF;;AAhJA;EACE,mBAAA;AAmJF;;AAjJA;EACE,yBAAA;AAoJF;;AAlJA;EACE,8BAAA;EACA,6BAAA;AAqJF;;AAnJA;EA2CI,gBAAA;AA4GJ;AAtJE;EACE,iBAAA;AAwJJ;AAtJE;EACE,mCAAA;AAwJJ;AAtJE;EACE,yBAAA;EACA,SAAA;AAwJJ;AAtJE;EACE,8BAAA;AAwJJ;AArJE;EACE,SAAA;AAuJJ;AArJI;EACE,UAAA;AAuJN;AApJI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AAsJN;AAnJI;EACE,WAAA;EACA,UAAA;AAqJN;AAlJI;EACE,WAAA;EACA,YAAA;AAoJN;AAhJE;EACE,cAAA;EACA,4BAAA;AAkJJ;AA/IE;EACA,mBAAA;AAiJF;AA/IE;EACE,4BAAA;AAiJJ;AA9IQ;EACI,eAAA;EACN,eAAA;AAgJN;AA5IE;EACE,4BAAA;AA8IJ;AA3IE;EACE,gCAAA;EACA,mBAAA;AA6IJ;AA3IE;EACE,mBAAA;EACA,iBAAA;AA6IJ;AA5II;EACE,kBAAA;AA8IN;AA3IE;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;AA6IJ;AA3II;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;AA6IN;AA1II;EACE,gBAAA;AA4IN;AA9HM;EACE,UAAA;AAgIR;AA1HI;EACE,aAAA;AA4HN;AAvHI;EACE,qBAAA;EACA,iBAAA;AAyHN;AAtHE;EFrGE,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEuGA,iCAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AA4HJ;AA1HI;EACE,mBAAA;AA4HN;AAzHI;EACE,gBAAA;AA2HN;AAzHM;EACE,gBAAA;AA2HR;AAvHI;EACE,eAAA;EACA,mCAAA;AAyHN;AArHE;EACE,6BAAA;EACA,oBAAA;AAuHJ;AApHE;EACE,uBAAA;AAsHJ;AApHI;EACE,kCAAA;AAsHN;AAlHE;EACE,qBAAA;EACA,iBAAA;AAoHJ;AAlHE;EACE,gCAAA;EACA,mBAAA;AAoHJ;AAlHE;EACE,kBAAA;AAoHJ;AFpRI;EEHJ;IAuKI,cAAA;EAoHF;EAlHE;IACE,yBAAA;EAoHJ;EAjHE;IACE,cAAA;IACA,kBAAA;IACA,WAAA;EAmHJ;EAhHE;IACE,SAAA;IACA,kBAAA;IACA,WAAA;EAkHJ;EA/GE;IACE,mBAAA;IACA,gBAAA;EAiHJ;EA/GE;IACE,mBAAA;IACA,iBAAA;EAiHJ;EAhHI;IACE,mBAAA;IACA,iBAAA;EAkHN;EAhHI;IACE,mBAAA;EAkHN;EAhHM;IACE,mBAAA;EAkHR;EA7GE;IACE,mBAAA;EA+GJ;EA9GI;IACE,eAAA;IACA,mBAAA;IACA,mCAAA;EAgHN;EA5GE;IACE,oBAAA;EA8GJ;EA3GE;IACE,kBAAA;IACA,mBAAA;EA6GJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.terms-understand {\n    font-size: 16px;\n    color:#333333;\n}\n\n.popupBreak{\n  margin-top: 20px;\n}\n\n.fanlist-without-accordion > p{\n  margin-bottom: 30px;\n}\n.checkbox .skin{\n  border: 1px solid #cccccc;\n}\n.fanlist-with-accordion .accordion {\n  border-bottom: none !important;\n  margin-bottom: 0px !important;\n  }\n.signup-review-section {\n  .review-btn-cancel {\n    padding-top: 10px;\n  }\n  .label-review{\n    font-family: 'Omnes-ATT-W02-Medium';\n  }\n  .icon-alert {\n    color: #ffb81c !important;\n    margin: 0;\n  }\n  .table{\n    margin-bottom: 30px !important;\n  }\n\n  .enrollDateInfo {\n    margin: 0;\n\n    a {\n      padding: 0;\n    }\n\n    .alert-icon {\n      width: 20px;\n      float: left;\n      margin-right: 10px;\n    }\n\n    .extra-content {\n      float: left;\n      width: 88%;\n    }\n\n    .icon-alert {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  h3{\n    color:#191919;\n    font: 2.4rem 'Omnes-ATT-W02';\n    } \n    margin: 0 16.66%;\n  a{\n  padding-right: 30px;\n  }\n  .btn-link {\n    font: 1.8rem 'Omnes-ATT-W02';\n  }\n    h3 {\n        a {\n            cursor: pointer;\n      font-size: 16px;\n\n        }\n    }\n  .checkbox span{\n    font-family: 'Omnes-ATT-W02';\n  }\n\n  .fanlist-with-accordion {\n    border-bottom: 1px solid color(default, dark);\n    margin-bottom: 20px;\n  }\n  .service-type {\n    margin-bottom: 30px;\n    padding-top: 10px;\n    p {\n      margin-bottom: 0px;\n    }\n  }\n  .editable-container {\n    border-top: 1px solid color(default, dark);\n    margin-bottom: 30px;\n    padding-top: 30px;\n\n    &.have-no-accordion {\n      border-top: 1px solid color(default, dark);\n      margin-bottom: 30px;;\n      padding-top: 30px;\n    }\n\n    p {\n      margin-bottom: 0;\n    }\n\n    // div {\n    //   margin-bottom: 30px;\n\n    //   &:last-child {\n    //     margin-bottom: 30px;\n    //   }\n    // }\n  }\n\n  tr {\n    th {\n      &:first-child {\n        width: 15%;\n      }\n    }\n  }\n\n  .fanlist-without-accordion {\n    .isMobileDevice {\n      display: none;\n    }\n  }\n\n  ul {\n    li {\n      list-style-type: disc;\n      margin-left: 15px;\n    }\n}\n  .reviewunderstand {\n    @include vendor-prefix('border-radius', '5px');\n    background-color: color(default, base);\n    border: 0 none;\n    margin-bottom: 30px;\n    padding: 20px;\n\n    p {\n      margin-bottom: 20px;\n    }\n\n    div {\n      margin-bottom: 0;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    h3.google-acknowledge {\n      font-size:20px;\n      font-family:'Omnes-ATT-W02-Medium';\n    }\n  }\n\n  .buttons-section {\n    border-top: 1px solid color(default, dark);\n    padding: 30px 0 60px;\n  }\n\n  .error-text {\n    color: color(danger, base);\n\n    .skin {\n      border: 1px solid color(danger, base);\n    }\n  }\n\n  .app-list {\n    list-style-type: disc;\n    margin-left: 15px;\n  }\n  .accordion-grid {\n    border-bottom: 1px solid  color(default, dark);\n    margin: 30px 0 30px;\n  }\n  .accordion-grid{\n    border-bottom: 0px; \n  }\n\n  @include respond-to (small) {\n    margin: 0 15px;\n\n    .review-btn-cancel {\n      padding: 20px 19px 0 18px;\n    }\n\n    .btn-cancel {\n      margin: 10px 0;\n      text-align: center;\n      width: 100%;\n    }\n\n    .btn {\n      margin: 0;\n      text-align: center;\n      width: 100%;\n    }\n\n    .service-type {\n      margin-bottom: 20px;\n      padding-top: 0px;\n    }\n    .editable-container {\n      margin-bottom: 20px;\n      padding-top: 20px;\n      &.have-no-accordion {\n        margin-bottom: 20px;;\n        padding-top: 20px;\n      }\n      div {\n        margin-bottom: 20px;\n\n        &.securitypolicy {\n          margin-bottom: 30px;\n        }\n      }\n    }\n\n    .reviewunderstand {\n      margin-bottom: 20px;\n      h3 {\n        font-size:20px;\n        margin-bottom: 20px;\n        font-family:'Omnes-ATT-W02-Medium';\n      }\n    }\n\n    .buttons-section {\n      padding: 20px 0 30px;\n    }\n\n    .grid-table {\n      margin-left: -15px;\n      margin-right: -15px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
